<template>
  <BittsLoading :is-loading="isLoading">
    <div class="c-shared-with-you-tab">
      <SharedWithYou
        :key="`${$route.fullPath}__shared_with_you`"
        @open-data-share-request-modal="onRequestData"
      />
      <DataShareRequestModal
        :data-share-request-modal-visible
        :org-ids
        :partner-pops
        @modal-closed="dataShareRequestModalVisible = false"
      />
    </div>
  </BittsLoading>
</template>

<script setup lang="ts">
import { BittsLoading } from '@crossbeam/bitts';

import { ref } from 'vue';

import DataShareRequestModal from '../../DataShareRequestModal.vue';
import SharedWithYou from '../../SharedWithYou.vue';

const isLoading = ref(false);
const dataShareRequestModalVisible = ref(false);
const orgIds = ref<number[]>([]);
const partnerPops = ref<Record<number, number[]>>({});

function onRequestData({
  orgId,
  partnerPop,
}: {
  orgId: number;
  partnerPop: number;
}) {
  dataShareRequestModalVisible.value = true;
  orgIds.value = [orgId];
  partnerPops.value = { [orgId]: [partnerPop] };
}
</script>

<style lang="pcss" scoped>
.c-shared-with-you-tab {
  @apply flex flex-col m-24 gap-20;
}
</style>
